import { render, staticRenderFns } from "./CreateSketchOld.vue?vue&type=template&id=b766d70e&scoped=true"
import script from "./CreateSketchOld.vue?vue&type=script&lang=js"
export * from "./CreateSketchOld.vue?vue&type=script&lang=js"
import style0 from "./CreateSketchOld.vue?vue&type=style&index=0&id=b766d70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b766d70e",
  null
  
)

export default component.exports